import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShower, faCartShopping, faGlassMartini, faFistRaised, faRedo, faComment, faEdit, faPlusSquare, faBookAtlas, faSchoolCircleCheck } from '@fortawesome/free-solid-svg-icons';
import './MyJersey.css';
import myjerseyimage from '../../assets/pageimages/MyJersey.webp';

function MyJerseyHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>MyJersey</h2>
      </div>
      <div className="main-content">
        <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
            <div className="button-links flex align-middle justify-center bg-gray-500">
              <div className="bottom-buttons-box"><Link to="/myjersey-library" className="top-button-link"><FontAwesomeIcon icon={faSchoolCircleCheck} className="myjersey-bottomlink-style" />My Target</Link></div>
              <div className="bottom-buttons-box"><Link to="/myjersey-artbook" className="top-button-link"><FontAwesomeIcon icon={faBookAtlas} className="myjersey-bottomlink-style" />My Achievement</Link></div>
              <div className="bottom-buttons-box"><Link to="/myjersey-create-master" className="top-button-link"><FontAwesomeIcon icon={faPlusSquare} className="myjersey-bottomlink-style" />My Eco Certificate</Link></div>
          </div>
        </div>
        <div className="image-container">
        <div className="relative inset-0 flex border border-b-gray-300">
            <img id="myjersey-id" src={myjerseyimage} alt="MyJersey Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default MyJerseyHome;
